import React from "react"
import {Box, Chip, Typography} from "@mui/material"
import AttachFileIcon from "@mui/icons-material/AttachFile"

import type {UnidentifiedAttachment} from "../types"

function formatAttachmentSize(sizeBytes: number): string {
	if (sizeBytes < 1024) return `${sizeBytes} B`
	if (sizeBytes < 1024 * 1024) return `${Math.round(sizeBytes / 1024)} KB`
	return `${(sizeBytes / (1024 * 1024)).toFixed(1)} MB`
}

function AttachmentChips({
	attachments,
	onDownload,
}: {
	attachments: UnidentifiedAttachment[] | null
	onDownload?: (attachment: UnidentifiedAttachment) => void
}) {
	if (!attachments?.length) return null

	return (
		<Box mt={1} display="flex" flexWrap="wrap" gap={1}>
			{attachments.map((attachment) => (
				<Box key={attachment.Index} display="flex" alignItems="center" gap={0.5}>
					<Chip
						label={attachment.Filename}
						title={attachment.Filename}
						size="small"
						icon={<AttachFileIcon />}
						onClick={onDownload ? () => onDownload(attachment) : undefined}
					/>
					<Typography variant="caption" color="textSecondary">
						{formatAttachmentSize(attachment.SizeBytes)}
					</Typography>
				</Box>
			))}
		</Box>
	)
}

export {AttachmentChips, formatAttachmentSize}
